import React, { Component } from 'react'

import { db } from '../firebase.js'
import './Card.css'
import grace from '../images/grace.png'



export default class Card extends Component {
  constructor(props) {
    super(props)

    this.handleTableClick = this.handleTableClick.bind(this)
  }

  handleTableClick(event) {
    event.preventDefault()
    let objectiveKey = event.target.innerHTML
    let userId = this.props.currentUser.uid
    let { userProgress } = this.props
    let newStatus = !userProgress[objectiveKey]
    document.getElementById(objectiveKey).className = `cardItem ${newStatus}`
    userProgress[objectiveKey] = newStatus
    db.collection('students').doc(userId).set({ [objectiveKey]: newStatus }, { merge: true })
  }

  render() {

    const letters = 'GRACE'.split('')
    const { userProgress } = this.props

    return (
      <div id="cardTableContainer">
        <table id="cardTable">
          <tbody>
            <tr id="cardHeader">
              <th>Git</th>
              <th>React</th>
              <th>API</th>
              <th>Cleanliness</th>
              <th>Extra</th>
            </tr>
            <tr className="bodyRow">
              {letters.map(letter => {
                let objectiveKey = letter + '1'
                return <td id={objectiveKey} key={objectiveKey} className={`cardItem ${userProgress[objectiveKey]}`} onClick={this.handleTableClick}>{objectiveKey}</td>
              })}
            </tr>
            <tr className="bodyRow">
              {letters.map(letter => {
                let objectiveKey = letter + '2'
                return <td id={objectiveKey} key={objectiveKey} className={`cardItem ${userProgress[objectiveKey]}`} onClick={this.handleTableClick}>{objectiveKey}</td>
              })}
            </tr>
            <tr className="bodyRow">
              {letters.map(letter => {
                let objectiveKey = letter + '3'
                return objectiveKey === 'A3'
                ? (
                  <td id={objectiveKey} key={objectiveKey} className={`cardItem ${userProgress[objectiveKey]}`}>
                    <img src={grace} alt="" />
                  </td>
                ) : (
                  <td id={objectiveKey} key={objectiveKey} className={`cardItem ${userProgress[objectiveKey]}`} onClick={this.handleTableClick}>{objectiveKey}</td>
                )
              })}
            </tr>
            <tr className="bodyRow">
              {letters.map(letter => {
                let objectiveKey = letter + '4'
                return <td id={objectiveKey} key={objectiveKey} className={`cardItem ${userProgress[objectiveKey]}`} onClick={this.handleTableClick}>{objectiveKey}</td>
              })}
            </tr>
            <tr className="bodyRow">
              {letters.map(letter => {
                let objectiveKey = letter + '5'
                return <td id={objectiveKey} key={objectiveKey} className={`cardItem ${userProgress[objectiveKey]}`} onClick={this.handleTableClick}>{objectiveKey}</td>
              })}
            </tr>
          </tbody>
        </table>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/Components/Card.js